import React, { useState, useEffect } from "react";
import { checkResult, createSelectOption } from "@/common";
import BraftEditor from "braft-editor";
import { Upload, ImgContainer } from "@/components";
import { NewsIdentifyName } from "../../childs/projectRec/projectFunction"
import { useWatchState, setState } from "@/store";
import { BaseService, uploadUrl } from "@/service";
import { Modal, message, Button, Form, Input, Icon, Row, Col, Popconfirm } from "antd";

const NAME = "projectEditNewsFiles";

const App = Form.create({ name: 'register' })((props) => {
    const add_date = parseInt(new Date().getTime() / 1000);
    const update_date = parseInt(new Date().getTime() / 1000);
    const { getFieldDecorator } = props.form;
    const [loading, setLoading] = useState(false);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { show, hide, width = 800, id, identify, callback } = modalProps;
    const [data, setData] = useState([]);
    const [profile, setProfile] = useState('');
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [files, setFiles] = useState([]);

    const formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
    };

    const getExpertDetail = (id) => {
        BaseService.list({
            table: "thtt_project_news",
            where: {
                id: id,
                "is_delete": 0,
            },
            process: {
                name: "files",
                key: "id",
                targetKey: "item_id",
                params: {
                    table: "thtt_attachment_relation",
                },
            }
        }).then(res => {
            if (!checkResult(res)) return;
            const data = res.data.result[0];
            const profile = BraftEditor.createEditorState(data.profile);
            const files = data.files;
            console.log("files", files)
            setFiles(data.files)
            setProfile(profile);
            setData(data);
        })
    }

    useEffect(() => {
        if (id) getExpertDetail(id)
    }, [id])

    const onChangeProfile = (e) => {
        modalProps.profile = e;
        setProfile(modalProps.profile.toHTML());
        console.log("modalProps.profile.toHTML()", modalProps.profile.toHTML())
    };

    /*附件上传组件，本段文件管理开始*/

    const onUploadFileFinish = (type, e) => {
        const size = e.file.size;
        const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
        const newFiles = e.file.response.files.map(({ fileShowName, suffix, url }) => ({ type, item_id: id, file_name: fileShowName, file_path: url, file_suffix: suffix, size, add_time }));
        if (!modalProps.files) modalProps.files = files;
        if (!modalProps.files[type]) modalProps.files[type] = newFiles;
        else modalProps.files[type] = modalProps.files[type].concat(newFiles);
        setProps({ ...modalProps });
    }

    const onRemoveFile = (id) => {
        BaseService.remove({
            table: "thtt_attachment_relation",
            where: { id: id }
        }).then(res => {
            if (!checkResult(res)) return;
            refeshFile();
        })
    }

    const refeshFile = async () => {
        const fileRes = await BaseService.list({
            table: "thtt_attachment_relation",
            where: { item_id: id, is_delete: 0 },
        })
        const files = fileRes.data.result;
        setFiles(files);
    }

    /*附件上传组件，本段文件管理结束*/

    const onSubmit = async (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            let _files = []
            Object.values(files).forEach((arr) => (_files = _files.concat(arr)));
            await BaseService.remove({
                table: "thtt_attachment_relation",
                where: {
                    item_id: data.id,
                    type: JSON.stringify(Object.keys(files)),
                },
            });
            await BaseService.adds({
                table: "thtt_attachment_relation",
                data: JSON.stringify(_files),
            });
            console.log("_files", JSON.stringify(_files))
            if (id !== 0) {
                if (!err) {
                    setLoading(true);
                    const res = await BaseService.put({
                        table: "thtt_project_news", data: {
                            title: values.title,
                            profile: (identify !== '3') ? modalProps.profile.toHTML() : modalProps.profile.toHTML,
                            update_date: update_date,
                        }, where: { id: id }
                    });
                    setLoading(false);
                    if (!checkResult(res)) return;
                    message.success("修改成功！");
                    if (callback) callback(res.data.result.id);
                    hide();
                }
            }
            if (id === 0) {
                if (!err) {
                    setLoading(true);
                    const res = await BaseService.add({
                        table: "thtt_project_news", data: {
                            title: values.title,
                            profile: (identify !== '3') ? modalProps.profile.toHTML() : '',
                            identify: identify,
                            add_date: add_date,
                            update_date: update_date,
                            is_delete: 0
                        }
                    });
                    console.log('添加的', res.data.result.id)
                    const resFileId=await BaseService.list({
                        table: "thtt_attachment_relation", data: {
                            item_id:res.data.result.id
                        },
                        where: {item_id: 0}
                    });
                    setLoading(false);
                    if (!checkResult(resFileId)) return;
                    message.success("添加成功！");
                    hide();
                    if (callback) callback();
                }
            }
        });
    }
    const onUploadFinish = (e) => {
        const url = e.file.response.files[0].url;
        data.photos = url;
        setState("modal." + NAME + ".data", { ...data });
    }

    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={onSubmit}>
                <div style={{ border: "1px solid #d9d9d9" }}>
                    <div style={{ textAlign: "center", backgroundColor: "#fafafa", marginBottom: 30, height: 50, borderBottom: "1px solid #d9d9d9" }}>
                        <h2>{(id !== 0) ? `修改${NewsIdentifyName(identify)}` : `新增${NewsIdentifyName(identify)}`}</h2>
                    </div>
                    <div style={{ marginLeft: 0 }}>
                        <Form.Item label="标题" type="flex" style={{ width: 720 }}>
                            {
                                (getFieldDecorator('title', {
                                    initialValue:
                                        [(id !== 0) ? data.title : ""],
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入标题',
                                        },
                                    ],
                                }
                                )(<Input placeholder="请输入标题" style={{ width: 550 }} />))
                            }
                        </Form.Item>
                        {(identify !== '3') ?
                            <Form.Item label="简介" style={{ width: 720 }} >
                                <BraftEditor
                                    className="border bor-ra-xs"
                                    value={(id !== 0) ? profile : ""}
                                    onChange={onChangeProfile}
                                    placeholder={`请输入简介`} />
                            </Form.Item>
                            :
                            <Form.Item
                                style={{ marginTop: 8, marginLeft: 80, width: "70%" }}>
                                {files.map(({ file_name, file_path, id }) => {
                                    return (<Row gutter={24} type="flex">
                                        <Col gutter={20}><Icon type="paper-clip" /><a href={`http://${UPLOAD_SERVER_HOST}${file_path}`} style={{ color: "blue", marginLeft: 8 }} target="_blank">{file_name}</a></Col>
                                        <Col>
                                            <Popconfirm
                                                title="确认要删除此附件吗？"
                                                onConfirm={onRemoveFile.later(id)}
                                                okText="确认"
                                                cancelText="取消"
                                            >
                                                <p className="link"><Icon type="delete" title="删除附件" /></p>
                                            </Popconfirm></Col>
                                    </Row>)
                                })}

                                <Upload
                                    style={{ minWidth: "160px", color: "blue", marginTop: 20 }}
                                    name="files"
                                    onFinish={onUploadFileFinish.later("enclosure")}
                                    action={uploadUrl}
                                >
                                    <Button><Icon type="upload" /> 上传</Button>
                                </Upload>

                            </Form.Item>
                        }
                        <p style={{ textAlign: "center", marginTop: 50, marginBottom: 20 }}>
                            <Button type="primary" onClick={onSubmit} loading={loading}>{(id !== 0) ? '修改' : '新增'}</Button>
                            <Button onClick={hide} style={{ marginLeft: 20 }}>取消</Button>
                        </p>
                    </div>
                </div>
            </Form>
        </Modal>
    );
})

export default App;